export enum EarnRoutePaths {
  Input = '/earn',
  Confirm = 'confirm',
}
